/* eslint-disable no-unused-vars */
export enum SeatPrice {
  Free = 'free',
  FreeWithMarkup = 'free_with_markup',
  PaidWithMarkup = 'paid_with_markup',
  PaidWithoutMarkup = 'paid_w/o_markup',
}
